export default __webpack_public_path__ + "static/person01-99550ef1de2e4ac667f84c660a93022a.png";